import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useDispatch } from "react-redux";
import { toastAlert } from "../../lib/toastAlert";
import Loader from '../../assets/images/uploadimg.png'
import { addcategory } from '../../actions/users';
import { useNavigate } from "react-router-dom";

const initialFormValue = {
    'name': "",
    'image': '',
    'BulkStatus': "false",
    'SubCategory': "",
    'Collection': "Mint"
}

const AddCategory = () => {

    const navigate = useNavigate();
    const [formValue, setFormValue] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});

    const [image_preview, Set_img_preview] = useState(Loader)

    const onChange = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        let formData = { ...formValue, ...{ [id]: value } }
        setFormValue(formData)
    }

    const handleFile = (e) => {
        e.preventDefault();
        const { id, files } = e.target;
        let formData = { ...formValue, ...{ [id]: files[0] } }
        setFormValue(formData)
    
    
        var validExtensions = ["png", 'gif', 'webp', 'PNG', 'jpg', 'JPEG', 'JPG']; //array of valid extensions
        if (e.target && e.target.files) {
          var reader = new FileReader()
          var file = e.target.files[0];
          var fileName = file.name;
          if (validExtensions.includes(String(file.name).split('/').pop()) == true) {
            toastAlert("error", "Only these file types are accepted : " + validExtensions.join(', '));
            return false;
          }
          const fileSize = file.size;
          if (5000000 < fileSize) {
            toastAlert("error", "File size exceeds 30 MB");
            return false;
          }
          else {
    
            var url = reader.readAsDataURL(file);
            reader.onloadend = function (e) {
              if (reader.result) {
                Set_img_preview(reader.result);
              }
            }.bind(this);
          }
        }
    
    
    
    };

    const handlechangeCheckBox = (e) => {
        const { id, Checked } = e.target;
        let formData = { ...formValue, [id]: e.target.checked };
        setFormValue(formData);
    };

    const handleFormSubmit = async (e) => {

        e.preventDefault();
        let reqData = {
          name,
          image,
          BulkStatus,
          SubCategory,
          Collection
        }

        if (!name) {
            toastAlert("error", "Fill category name")
            return
        }
    
        const resp = await addcategory(reqData);
        
        if (resp?.success) {
          toastAlert("success", 'Category details added');
          setTimeout(
            () => window.location.href = '/categorylist'
            , 1000)
        } else {
          if (resp?.errors) {
            setValidateError(resp?.errors);
          } else toastAlert("error", resp?.msg)
    
        }
      }
    
    const {
        name, image, BulkStatus, SubCategory,Collection
    } = formValue

    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Add Category'} />
                        <div className='common_page_scroller mt-5 pe-2'>

                             <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>

                            <form noValidate onSubmit={handleFormSubmit} autoComplete="off">
                                <div className="addcategorys">
                                    <h4>Add Category</h4>
                                </div>

                                <div className="categorylisdt">
                                
                                <div className='row'>
                                    <div className='col-xl-5'>
                                    <div className='mt-3'>
                                        <label htmlFor="name" className='mb-2'>Category name</label>
                                        <input
                                        className='form-control'
                                        placeholder='Category name'
                                            type="text"
                                            id="name"
                                            onChange={onChange}
                                            value={name}
                                            fullWidth
                                        />
                                        {validateError.name && <span className="text-danger">{validateError.name}</span>}
                                    </div>
                                    </div>
                                    <div className='col-xl-5'>
                                    <div className='mt-3'>
                                        <div>
                                            <label htmlFor="image" className='mb-2'>Image</label> <br></br>
                                            <input
                                                type="file"
                                                id="image"
                                                onChange={handleFile}
                                                className="inputfileadd"
                                                fullWidth
                                            /><br></br>
                                            <label className='mb-2 mt-2'>Image Preview</label><br></br>
                                            <img src={image_preview} alt="category image" style={{ maxHeight: 100, maxWidth: 100 }} />
                                            {validateError.photo && <span className="text-danger">{validateError.photo}</span>}
                                        </div>
                                    </div>
                                    </div>
                                    <div className='col-xl-5'>
                                    <div className='mt-3 mb-2 d-flex align-items-center'>
                                        <input
                                            type="checkbox"
                                            className='me-2'
                                            id="BulkStatus"
                                            name="BulkStatus"
                                            value="BulkStatus"
                                            onChange={(e) => handlechangeCheckBox(e)}
                                        />
                                        <label htmlFor="BulkStatus mb-0 ms-2"> ( If you Click the check box this category will show only on bulk Collection)</label>
                                    </div>
                                    
                                    {formValue?.BulkStatus === "true" || formValue?.BulkStatus === true && (
                                        <div>
                                            <label htmlFor="SubCategory" className='mb-2'>Sub Category name</label>
                                            <input
                                            className='form-control'
                                                type="text"
                                                id="SubCategory"
                                                onChange={onChange}
                                                value={SubCategory}
                                                fullWidth
                                            />
                                            {validateError.SubCategory && <span className="text-danger">{validateError.SubCategory}</span>}
                                        </div>
                                    )}
                                    </div>
                                </div>
                                  
                               

                                </div>

                                <div>
                                    <button className='btn addcate mt-4' type="submit">Add</button>
                                </div>
                            </form>

                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default AddCategory